import React from 'react'
import PropTypes from 'prop-types'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'

function WhenModelValuesNotEqual (props) {
  const { name1, name2, children } = props

  return useValue(name1) !== useValue(name2) ? children : null
}

WhenModelValuesNotEqual.propTypes = {
  name1: PropTypes.string.isRequired,
  name2: PropTypes.string.isRequired
}

export default observer(WhenModelValuesNotEqual)
